// src/crm/ugc/ReferralsTab.tsx
//
// Onglet « Parrainages » du programme UGC (spec § 6.4) : parrain, personne parrainée, date
// d'acceptation, état (en attente, gagné, réglé) et montant. Lecture seule : un parrainage se
// gagne au figement d'un montant et se règle dans « Publications et paiements ».

import { formatEuros } from '../../../functions/lib/ugc/rules'
import type { AdminReferralItem } from '../../lib/ugcTypes'
import { formatDate } from './format'
import { useUgcReferrals } from './hooks'

function stateLabel(item: AdminReferralItem): string {
  if (item.bonus.status === 'pending') return 'En attente'
  if (item.payState === 'paid' || item.payState === 'settled') return 'Réglé'
  if (item.payState === 'invoice_received') return 'Facture reçue'
  return 'Gagné'
}

export function ReferralsTab() {
  const referrals = useUgcReferrals()

  return (
    <section className="ugc-tab-panel" aria-label="Parrainages">
      {referrals.isPending && <p className="ugc-muted">Chargement…</p>}
      {referrals.isError && (
        <p className="ugc-error">Les parrainages n'ont pas pu être chargés : {referrals.error.message}</p>
      )}
      {referrals.data?.length === 0 && <p className="ugc-empty">Aucun parrainage pour l'instant.</p>}
      {referrals.data && referrals.data.length > 0 && (
        <div className="ugc-table-wrap">
          <table className="ugc-table">
            <thead>
              <tr>
                <th scope="col">Personne parrainée</th>
                <th scope="col">Parrain</th>
                <th scope="col">Acceptée le</th>
                <th scope="col">État</th>
                <th scope="col" className="ugc-num">
                  Montant
                </th>
              </tr>
            </thead>
            <tbody>
              {referrals.data.map((item) => (
                <tr key={item.bonus.id}>
                  <td>{item.referredName}</td>
                  <td>{item.referrerName}</td>
                  <td>{formatDate(item.acceptedAt)}</td>
                  <td>{stateLabel(item)}</td>
                  <td className="ugc-num">{formatEuros(item.bonus.amountCents)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
